import { render, staticRenderFns } from "./TransferAccount.vue?vue&type=template&id=d2dd2c74&"
import script from "./TransferAccount.vue?vue&type=script&lang=js&"
export * from "./TransferAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports